// extracted by mini-css-extract-plugin
export default {"myBtn":"MyButton_myBtn__8Pp5Z"};